import client from "./http-client";
import { API_HOST } from "../config";

export const upload = (document) => {
  const formData = new FormData();
  formData.append("file", document);

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  return client.post(`${API_HOST}/documents/`, formData, config);
};

export const get = (documentId) =>
  client.get(`${API_HOST}/documents/${documentId}`);

export const ocr = (documentId) =>
  client.get(`${API_HOST}/documents/${documentId}/ocr`, {
    params: { include_raw_types: true },
  });

export const extractions = (documentId) =>
  client.get(`${API_HOST}/documents/${documentId}/extractions`);

export const processedPages = (documentId) =>
  client.get(`${API_HOST}/documents/${documentId}/processed`);
